import { inject, Service } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { Store } from '@lib.core/store/store.service';

@Service()
export class CountryCodeStore {
  private readonly store = inject(Store);
  private readonly key = 'countryCode';

  setCountryCode(countryCode: string | null): void {
    this.store.setValue<string>(this.key, countryCode);
  }

  getCountryCode(): Observable<string> {
    return this.store.getValue<string>(this.key).pipe(
      filter((countryCode: string | null | undefined) => countryCode !== null && countryCode !== undefined)
    );
  }
}
